import { createApi } from '@reduxjs/toolkit/query/react';
import { PERMISSION_API_URL } from '../../utils/apiEndpoints';
import fetchQuery from '../../apiClient/fetchQuery';

export const filePermissionApi = createApi({
  reducerPath: 'filePermissionApi',
  baseQuery: fetchQuery,
  endpoints: (builder) => ({
    fetchAllUsers: builder.query({
      query: ({ workspaceId, fileId }) => ({
        url: `${PERMISSION_API_URL}/${fileId ? `files/${fileId}` : 'workspaces'}?workspace_id=${workspaceId}`,
      }),
      transformResponse: (response) => ({
        users: response,
      }),
    }),
    addPermission: builder.mutation({
      query: (data) => ({
        url: `${PERMISSION_API_URL}`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
    updatePermission: builder.mutation({
      query: ({ username, organization_id, workspace_id, file_id, data }) => ({
        url: `${PERMISSION_API_URL}?username=${username}&organization_id=${organization_id}&workspace_id=${workspace_id}${file_id ? `&file_id=${file_id}` : ''}`,
        method: 'PUT',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
    deletepermission: builder.mutation({
      query: ({ username, organization_id, workspace_id, file_id }) => ({
        url: `${PERMISSION_API_URL}?username=${username}&organization_id=${organization_id}&workspace_id=${workspace_id}${file_id ? `&file_id=${file_id}` : ''}`,
        method: 'DELETE',
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
    getAllRequests: builder.query({
      query: () => ({
        url: `${PERMISSION_API_URL}/requests`,
      }),
      transformResponse: (response) => ({
        requests: response,
      }),
    }),
    acceptRequest: builder.mutation({
      query: (data) => ({
        url: `${PERMISSION_API_URL}/requests/accept`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
    rejectRequest: builder.mutation({
      query: (data) => ({
        url: `${PERMISSION_API_URL}/requests/reject`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
    getFileLink: builder.query({
      query: ({ userEmail, fileId }) => ({
        url: `${PERMISSION_API_URL}/get-file-link?user_email=${userEmail}&file_id=${fileId}`,
      }),
      transformResponse: (response) => ({
        users: response,
      }),
    }),
    updateFileLinkPermission: builder.mutation({
      query: (data) => ({
        url: `${PERMISSION_API_URL}/add-link`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
    requestFilePermission: builder.mutation({
      query: (data) => ({
        url: `${PERMISSION_API_URL}/file-access`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
  }),
});

export const {
  useLazyFetchAllUsersQuery,
  useAddPermissionMutation,
  useUpdatePermissionMutation,
  useDeletepermissionMutation,
  useLazyGetFileLinkQuery,
  useLazyGetAllRequestsQuery,
  useUpdateFileLinkPermissionMutation,
  useAcceptRequestMutation,
  useRejectRequestMutation,
  useRequestFilePermissionMutation,
} = filePermissionApi;
